<h2 mat-dialog-title class="head-title">Previous Vessel Details for {{destinationName}}</h2>
<div class="table-scroll">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 full-width-table">
    <!-- Vessel Voyage -->
    <ng-container matColumnDef="vesselVoyage">
      <th mat-header-cell *matHeaderCellDef>
        <span class="header-label">Vessel Voyage</span>
        <div class="search-filter">
          <input placeholder="Search..." [formControl]="vesselVoyageFilter">
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.vesselVoyage }} - ({{row.voyageNo}})</td>
    </ng-container>

    <!-- Consortium -->
    <ng-container matColumnDef="consortium">
      <th mat-header-cell *matHeaderCellDef>Consortium</th>
      <td mat-cell *matCellDef="let row">{{ row.consortium }}</td>
    </ng-container>

    <!-- Line -->
    <ng-container matColumnDef="line">
      <th mat-header-cell *matHeaderCellDef>Line</th>
      <td mat-cell *matCellDef="let row">{{ row.line }}</td>
    </ng-container>

    <!-- Week No -->
    <ng-container matColumnDef="weekNo">
      <th mat-header-cell *matHeaderCellDef>Week No</th>
      <td mat-cell *matCellDef="let row">{{ row.weekNo }}</td>
    </ng-container>

    <!-- ATD POL -->
    <ng-container matColumnDef="atdPol">
      <th mat-header-cell *matHeaderCellDef>ATD POL</th>
      <td mat-cell *matCellDef="let row">{{ row.atdPol ? (row.atdPol | date:'dd-MM-yyyy') : '---' }}</td>
    </ng-container>

    <!-- Routing -->
    <ng-container matColumnDef="routingId">
      <th mat-header-cell *matHeaderCellDef>Routing</th>
      <td mat-cell *matCellDef="let row">{{ row.routingId }}</td>
    </ng-container>

    <!-- Transit Time -->
    <ng-container matColumnDef="transitTime">
      <th mat-header-cell *matHeaderCellDef>TT Time</th>
      <td mat-cell *matCellDef="let row">{{ row.transitTime }} Days</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

@if (noPreviousVessel) {
  <div class="no-data-banner">
    <mat-icon class="no-data-banner__icon">history</mat-icon>
    <span class="no-data-banner__title">No Previous Data Found</span>
    <span class="no-data-banner__message">No previous vessel records are available for this destination.</span>
  </div>
}

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="popup-close-btn">Close</button>
</mat-dialog-actions>
